/**
 * ================================================================
 * Bisou Rivage V5 — bisou-variant-ui.js
 * ================================================================
 *
 * Trois modules autonomes (IIFE) :
 *
 *   1. VARIANT UI
 *      Selecteur format / cadre / couleur, synchronisation avec
 *      les <select> natifs Shopify, mise a jour du prix, du stock
 *      et du bouton ATC.
 *
 *   2. S2 SCROLL ACCELERE
 *      La section "Associe le" remonte 1.3x plus vite que le
 *      scroll normal pour un effet de reveal (desktop >= 900 px).
 *
 *   3. ASSOCIATED PRODUCTS
 *      Fetch des recommandations Shopify, filtrage par orientation
 *      (V-/H- dans le titre), affichage de 2 cards max et synchro
 *      des images avec le variant principal.
 *
 * ================================================================
 */


/* ================================================================
   1. VARIANT UI
   ================================================================ */
(function () {
  'use strict';

  var fmtList = document.getElementById('rv5-bloc-fmt');
  if (!fmtList) return;

  /* ── 1.0  Bridge lang (injecté par Liquid, avec fallbacks FR) ── */
  var VCFG = (window.BISOU_VARIANT_CFG && window.BISOU_VARIANT_CFG.lang) || {};

  /* ── 1.1  Constantes ─────────────────────────────────────────── */

  /** Labels affiches pour chaque couleur de cadre */
  var LABELS = {
    'none':    VCFG.frameNone    || 'Sans cadre',
    'noir':    VCFG.frameBlack   || 'Cadre Noir',
    'blanc':   VCFG.frameWhite   || 'Cadre Blanc',
    'chene':   VCFG.frameOak     || 'Cadre Ch\u00eane',
    'bouleau': VCFG.frameBirch   || 'Cadre Bouleau'
  };

  /** Suffixe taille cadre utilise dans le titre du variant Shopify */
  var VARIANT_FRAME_SIZES = {
    A2: '50x70cm',
    A3: '40x50cm',
    A4: '30x40cm'
  };

  /* ── 1.2  Donnees injectees par Liquid (data-attributes) ─────── */

  var remaining = {
    A2: parseInt(fmtList.dataset.remainingA2) || 0,
    A3: parseInt(fmtList.dataset.remainingA3) || 0,
    A4: parseInt(fmtList.dataset.remainingA4) || 0
  };

  var prices = {
    A2: { cadre: parseInt(fmtList.dataset.priceA2Cadre) || 0, sans: parseInt(fmtList.dataset.priceA2Sans) || 0 },
    A3: { cadre: parseInt(fmtList.dataset.priceA3Cadre) || 0, sans: parseInt(fmtList.dataset.priceA3Sans) || 0 },
    A4: { cadre: parseInt(fmtList.dataset.priceA4Cadre) || 0, sans: parseInt(fmtList.dataset.priceA4Sans) || 0 }
  };

  var sectionId = fmtList.dataset.sectionId;

  /* ── 1.2.b  Lookup variants (fallback fiable iPad Safari) ─────── */
  var variants = [];
  try {
    var varScript = document.getElementById('rv5-variants-' + sectionId);
    if (varScript) variants = JSON.parse(varScript.textContent);
  } catch (e) { variants = []; }

  /* Trouve l'ID du variant correspondant a l'etat courant (format + cadre + couleur) */
  function findVariantId() {
    if (!variants.length) return null;
    var fmt = state.format.toLowerCase();
    var isNone = !state.withFrame || state.color === 'none';
    var col = state.color;
    var cFr = col === 'chene' ? 'ch\u00eane' : col;
    var cEnMap = { 'noir': 'black', 'blanc': 'white', 'chene': 'oak', 'bouleau': 'birch' };
    var cEn = cEnMap[col];

    for (var i = 0; i < variants.length; i++) {
      var t = variants[i].t || '';
      if (t.indexOf(fmt) === -1) continue;
      if (isNone) {
        if (t.indexOf('sans') !== -1 || t.indexOf('no frame') !== -1 ||
            t.indexOf('unframed') !== -1 || t.indexOf('papier') !== -1 ||
            t.indexOf('paper') !== -1) {
          return variants[i].id;
        }
      } else {
        var hasColor = t.indexOf(cFr) !== -1 || (cEn && t.indexOf(cEn) !== -1) || t.indexOf(col) !== -1;
        var hasFrame = t.indexOf('cadre') !== -1 || t.indexOf('frame') !== -1;
        if (hasColor && hasFrame) return variants[i].id;
      }
    }
    return null;
  }

  /* Met a jour DIRECTEMENT l'input name="id" du form (contourne variant-selects
     qui peut echouer sur iPad Safari avec un <select> completement cache).
     Met aussi a jour l'URL ?variant=xxx pour coherence si partage. */
  function updateFormVariantId() {
    var vid = findVariantId();
    if (!vid) return;
    var forms = document.querySelectorAll('form[action*="/cart/add"]');
    for (var i = 0; i < forms.length; i++) {
      var input = forms[i].querySelector('input[name="id"]');
      if (input) {
        /* Force enabled + value via 2 mecanismes pour fiabilite iOS */
        input.disabled = false;
        input.removeAttribute('disabled');
        input.value = vid;
        input.setAttribute('value', vid);
      }
    }
    /* Met a jour l'URL sans rechargement (pour que le partage pointe sur le bon variant) */
    try {
      var url = new URL(window.location.href);
      url.searchParams.set('variant', vid);
      window.history.replaceState({}, '', url);
    } catch (e) {}
  }

  /* Met a jour l'image principale via DIRECT SWAP du src.
     Approche qui marche sur iOS car elle ne depend PAS de :
     - fetch() Shopify (echoue sur iOS)
     - Media gallery DOM swap (l'image du variant n'est pas dans le DOM)
     - variant-selects custom element et son pubsub

     Meme pattern que "Associez le" qui marche sur iPhone. */
  function updateFeaturedImage() {
    var vid = findVariantId();
    if (!vid) return;
    var v = null;
    for (var i = 0; i < variants.length; i++) {
      if (variants[i].id === vid) { v = variants[i]; break; }
    }
    if (!v || !v.img) return;

    var gallery = document.querySelector('media-gallery');
    if (!gallery) return;

    /* Cible le premier img visible (celui qui est affiche) */
    var activeItem = gallery.querySelector('.product__media-item.is-active')
                  || gallery.querySelector('[data-media-id].is-active')
                  || gallery.querySelector('.product__media-item')
                  || gallery.querySelector('[data-media-id]');
    if (!activeItem) return;

    var img = activeItem.querySelector('img');
    if (!img) return;

    var newSrc = v.img;
    var currentSrc = (img.getAttribute('src') || '').split('?')[0];
    var targetSrc = newSrc.split('?')[0];
    if (currentSrc === targetSrc) return; /* Deja la bonne image */

    /* CRUCIAL : supprimer srcset sinon Safari garde l'ancienne image via responsive */
    img.removeAttribute('srcset');
    img.removeAttribute('data-srcset');
    img.setAttribute('src', newSrc);

    /* Miroir dans la modale plein-ecran si elle existe */
    var mediaId = activeItem.getAttribute('data-media-id');
    if (mediaId) {
      var modalImg = document.querySelector('product-modal [data-media-id="' + mediaId + '"] img');
      if (modalImg) {
        modalImg.removeAttribute('srcset');
        modalImg.removeAttribute('data-srcset');
        modalImg.setAttribute('src', newSrc);
      }
    }
  }

  /* ── 1.3  Etat courant ───────────────────────────────────────── */

  var state = {
    format:    fmtList.dataset.initFormat || 'A4',
    withFrame: fmtList.dataset.initCadre === 'true',
    color:     fmtList.dataset.initColor || 'none'
  };

  /* ── 1.4  References DOM ─────────────────────────────────────── */

  var formatRows = fmtList.querySelectorAll('.rv5-format-row');
  var btnSans    = document.querySelector('.rv5-btn-sans');
  var btnAvec    = document.querySelector('.rv5-btn-avec');
  var colorLabel = document.getElementById('rv5-color-label');
  var swatches   = document.querySelectorAll('.rv5-color-swatch');
  /* Inventaire suivi par Shopify ? Sans lui, inventory_quantity vaut 0 partout
     et le compteur mentirait : pose par snippets/bisou-variant-ui.liquid. */
  var stockTracked = fmtList.dataset.stockTracked === 'true';
  var stockText  = document.getElementById('rv5-stock-text');
  var stockFill  = document.getElementById('rv5-stock-fill');
  var atcPrice   = document.querySelector('.bisou-atc-price');

  /* Cree le <span> prix dans chaque format row s'il n'existe pas */
  formatRows.forEach(function (row) {
    if (!row.querySelector('.rv5-f-price')) {
      var span = document.createElement('span');
      span.className = 'rv5-f-price';
      row.appendChild(span);
    }
  });

  /* ── 1.5  Helpers ────────────────────────────────────────────── */

  /** Majuscule + accent pour les couleurs ("chene" -> "Chene") */
  function capitalizeColor(col) {
    if (col === 'chene') return 'Ch\u00eane';
    return col.charAt(0).toUpperCase() + col.slice(1);
  }

  /** Convertit un prix en centimes -> "45 EUR" (sans decimales) */
  function formatMoney(cents) {
    if (!cents) return '';
    return Math.round(cents / 100) + ' \u20ac';
  }

  /* ── 1.6  Synchronisation variant Shopify (bilingual matcher) ── */
  function selectNativeVariant() {
    var vs = document.querySelector('variant-selects');
    if (!vs) return;
    var selects = vs.querySelectorAll('select');
    if (!selects.length) return;

    var fmt = state.format.toLowerCase();
    var isNone = !state.withFrame || state.color === 'none';
    var col = state.color;

    function matchFormat(txt) { return txt.indexOf(fmt) !== -1; }
    function matchFinition(txt) {
      if (isNone) {
        return txt.indexOf('sans') !== -1
            || txt.indexOf('no frame') !== -1
            || txt.indexOf('unframed') !== -1
            || txt.indexOf('papier') !== -1
            || txt.indexOf('paper') !== -1;
      }
      var cFr = col === 'chene' ? 'ch\u00eane' : col;
      var cEnMap = { 'noir': 'black', 'blanc': 'white', 'chene': 'oak', 'bouleau': 'birch' };
      var cEn = cEnMap[col];
      var hasColor = txt.indexOf(cFr) !== -1
                  || (cEn && txt.indexOf(cEn) !== -1)
                  || txt.indexOf(col) !== -1;
      var hasFrame = txt.indexOf('cadre') !== -1 || txt.indexOf('frame') !== -1;
      var sizeStr = (VARIANT_FRAME_SIZES[state.format] || '').toLowerCase();
      var hasSize = sizeStr && txt.indexOf(sizeStr) !== -1;
      return hasColor && (hasFrame || hasSize);
    }

    function setRobustValue(sel, checkFn) {
      var options = sel.querySelectorAll('option');
      for (var i = 0; i < options.length; i++) {
        if (checkFn(options[i].textContent.toLowerCase())) {
          if (sel.value !== options[i].value) {
            var prev = sel.querySelector('option[selected]');
            if (prev) prev.removeAttribute('selected');
            sel.value = options[i].value;
            options[i].setAttribute('selected', 'selected');
            return true;
          }
          return false;
        }
      }
      return false;
    }

    if (selects.length === 1) {
      setRobustValue(selects[0], function (txt) { return matchFormat(txt) && matchFinition(txt); });
    } else {
      for (var j = 0; j < selects.length; j++) {
        var name = (selects[j].getAttribute('name') || '').toLowerCase();
        if (name.indexOf('format') !== -1 || name.indexOf('taille') !== -1 || name.indexOf('size') !== -1) {
          setRobustValue(selects[j], matchFormat);
        } else {
          setRobustValue(selects[j], matchFinition);
        }
      }
    }

    /* Garantit que chaque <select> a l'attribut HTML "selected" sur son option courante.
       Sans cela, global.js:updateSelectionMetadata() peut crasher (find() retourne undefined)
       et empeche le publish() qui declenche la mise a jour de l'image. */
    for (var k = 0; k < selects.length; k++) {
      if (!selects[k].querySelector('option[selected]') && selects[k].selectedOptions[0]) {
        selects[k].selectedOptions[0].setAttribute('selected', 'selected');
      }
    }

    setTimeout(function () {
      selects[selects.length - 1].dispatchEvent(new Event('change', { bubbles: true }));
    }, 50);
  }

  /* ── 1.7  Fonctions de mise a jour UI ────────────────────────── */

  /** Barre de stock : texte, largeur, couleur, hint */
  function updateStock() {
    if (!stockText || !stockFill) return;

    var r = remaining[state.format] || 0;
    if (r < 0) r = 0;
    if (r > 10) r = 10;

    var pct = (r / 10) * 100;
    var colorHex;

    if (r === 0) {
      stockText.textContent = (VCFG.stockSoldOut || '\u00c9puis\u00e9 en {format}').replace('{format}', state.format);
      pct = 100;
      colorHex = '#d94532';
    } else {
      stockText.textContent = (VCFG.stockRemaining || '{remaining}/10 restants').replace('{remaining}', r).replace('{total}', 10);
      if (r === 10)     colorHex = '#c8c8c8';
      else if (r <= 3)  colorHex = '#d94532';
      else if (r <= 6)  colorHex = '#f5a623';
      else              colorHex = '#111111';
    }

    stockFill.style.cssText = 'width: ' + pct + '% !important; background-color: ' + colorHex + ' !important; height: 3px !important; transition: width 0.3s;';
    stockFill.classList.toggle('rv5-progress--full', pct >= 100 && r > 0);

    var hint = document.getElementById('rv5-stock-hint');
    /* « Vous obtiendrez le tirage n°1 » n'a de sens que si l'inventaire est suivi :
       sinon tout le monde lirait « n°1 ». Sans compteur fiable, la ligne se tait. */
    if (hint && !stockTracked) { hint.hidden = true; hint.textContent = ''; }
    if (hint && stockTracked) {
      hint.hidden = false;
      if (r >= 7 && r <= 10)  hint.textContent = (VCFG.stockNextPrint || 'Vous obtiendrez le tirage n\u00b0{n}').replace('{n}', 11 - r);
      else if (r <= 5)        hint.textContent = VCFG.stockNoRestock  || 'Pas de restock';
      else                    hint.textContent = VCFG.stockAlmostOut  || 'Bient\u00f4t \u00e9puis\u00e9';
    }
  }

  /** Panneau « edition limitee » : il affiche les memes compteurs que la fiche,
   *  et se tait de la meme facon quand l'inventaire n'est pas suivi. */
  function updateEditionPanel() {
    var r = remaining[state.format] || 0;
    if (r < 0) r = 0;
    if (r > 10) r = 10;
    var rem = document.querySelector('[data-rv5-edition-remaining]');
    var num = document.querySelector('[data-rv5-edition-number]');
    var DASH = '\u2014';
    if (rem) rem.textContent = stockTracked ? (r + '/10') : DASH;
    if (num) num.textContent = (stockTracked && r > 0) ? ('n\u00b0' + (11 - r)) : DASH;
  }

  /** Label "SANS CADRE" / "Cadre Noir" sous les swatches */
  function updateColorLabel() {
    if (!colorLabel) return;
    colorLabel.textContent = (state.color === 'none')
      ? (VCFG.frameNoneUpper || 'SANS CADRE')
      : (LABELS[state.color] || VCFG.frameNoneUpper || 'SANS CADRE');
  }

  /** Classe .active sur le bon swatch */
  function updateSwatches() {
    swatches.forEach(function (s) {
      var col = s.dataset.col;
      s.classList.toggle('active', state.withFrame ? col === state.color : col === 'none');
    });
  }

  /** Classe .active sur Sans / Avec cadre */
  function updateFrameButtons() {
    if (!btnSans || !btnAvec) return;
    btnSans.classList.toggle('active', !state.withFrame);
    btnAvec.classList.toggle('active', state.withFrame);
  }

  /** Prix + dimensions (papier/cadre) + etat actif sur chaque ligne format */
  function updateFormatRows() {
    var isFramed = state.withFrame;
    formatRows.forEach(function (row) {
      var f = row.dataset.f;
      row.classList.toggle('active', f === state.format);
      var priceSpan = row.querySelector('.rv5-f-price');
      if (priceSpan) {
        priceSpan.textContent = formatMoney(isFramed ? prices[f].cadre : prices[f].sans);
      }
      /* Dimensions : cadre si avec cadre, papier sinon (lues depuis data-dim-frame / data-dim-paper) */
      var dimVal = row.querySelector('.rv5-f-dim-val');
      if (dimVal) {
        var txt = isFramed ? row.dataset.dimFrame : row.dataset.dimPaper;
        if (txt) dimVal.innerHTML = txt;
      }
    });
  }

  /** Prix affiche dans le bouton ATC */
  function updateAtcPrice() {
    if (!atcPrice) return;
    atcPrice.textContent = formatMoney(state.withFrame ? prices[state.format].cadre : prices[state.format].sans);
  }

  /** Livraison offerte : deux libelles, jamais les deux a la fois.
   *   au-dessus du seuil -> « Livraison offerte » + pastille verte
   *   en-dessous         -> « Livraison offerte des 150 EUR » en gris
   *  Le seuil vient de data-threshold, pose par snippets/bisou-variant-ui.liquid
   *  depuis le reglage de theme bisou_free_shipping_threshold : un seul endroit
   *  ou le changer, ici comme la-bas. */
  function updateShipping() {
    var currentPrice = state.withFrame ? prices[state.format].cadre : prices[state.format].sans;
    var spans = document.querySelectorAll('.rv5-shipping-aside');
    for (var i = 0; i < spans.length; i++) {
      var euros = parseInt(spans[i].getAttribute('data-threshold'), 10);
      if (isNaN(euros)) euros = 150;
      var isFree = currentPrice >= euros * 100;
      spans[i].classList.toggle('rv5-ship-free', isFree);
      var txt = spans[i].querySelector('.rv5-ship-txt');
      if (txt) {
        var label = isFree ? txt.getAttribute('data-ship-free') : txt.getAttribute('data-ship-from');
        if (label && txt.textContent !== label) txt.textContent = label;
      }
    }
  }

  /* ── 1.8  Etat global (pour la synchro associated products) ──── */

  window.__bisouState = state;

  /* ── 1.9  Master update ──────────────────────────────────────── */

  var updatingFromUI = false;

  function updateAll() {
    updatingFromUI = true;
    updateStock();
    updateColorLabel();
    updateSwatches();
    updateFrameButtons();
    updateFormatRows();
    updateAtcPrice();
    updateShipping();
    updateEditionPanel();
    /* FIX iPad Safari : force l'ID variant dans le form AVANT selectNativeVariant.
       Comme ca meme si variant-selects echoue, le cart recoit le bon variant. */
    updateFormVariantId();
    updateFeaturedImage();
    selectNativeVariant();
    document.dispatchEvent(new CustomEvent('bisou:variant-change', { detail: state }));
    setTimeout(function () { updatingFromUI = false; }, 200);
  }

  /* ── 1.10  Ecouteurs d'evenements ────────────────────────────── */

  /* Clic sur une ligne format (A2 / A3 / A4) */
  formatRows.forEach(function (row) {
    row.addEventListener('click', function () {
      formatRows.forEach(function (r) { r.classList.remove('active'); });
      row.classList.add('active');
      state.format = row.dataset.f;
      updateAll();
    });
  });

  /* Bouton "Sans cadre" */
  if (btnSans) {
    btnSans.addEventListener('click', function () {
      state.withFrame = false;
      state.color = 'none';
      updateAll();
    });
  }

  /* Bouton "Avec cadre" */
  if (btnAvec) {
    btnAvec.addEventListener('click', function () {
      state.withFrame = true;
      if (state.color === 'none') state.color = 'noir';
      updateAll();
    });
  }

  /* Clic sur un swatch couleur */
  swatches.forEach(function (sw) {
    sw.addEventListener('click', function () {
      var col = sw.dataset.col;
      if (col === 'none') {
        state.withFrame = false;
        state.color = 'none';
      } else {
        state.withFrame = true;
        state.color = col;
      }
      updateAll();
    });
  });

  /* Bouton partager */
  var shareBtns = document.querySelectorAll('.rv5-btn-share');
  shareBtns.forEach(function (shareBtn) {
    /* Toast feedback visuel (uniquement pour le fallback clipboard) */
    var shareToast = document.createElement('span');
    shareToast.style.cssText = 'position:absolute;bottom:calc(100% + 6px);left:50%;transform:translateX(-50%);background:#111;color:#fff;font-size:10px;letter-spacing:.08em;padding:5px 10px;border-radius:4px;white-space:nowrap;pointer-events:none;opacity:0;transition:opacity .2s;z-index:999;';
    shareToast.textContent = VCFG.linkCopied || 'Lien copi\u00e9 !';
    shareBtn.style.position = 'relative';
    shareBtn.appendChild(shareToast);

    function showShareToast() {
      shareToast.style.opacity = '1';
      setTimeout(function () { shareToast.style.opacity = '0'; }, 2000);
    }

    function copyFallback() {
      if (navigator.clipboard && navigator.clipboard.writeText) {
        navigator.clipboard.writeText(window.location.href).then(showShareToast).catch(legacyCopy);
      } else {
        legacyCopy();
      }
    }

    function legacyCopy() {
      var inp = document.createElement('input');
      inp.value = window.location.href;
      document.body.appendChild(inp);
      inp.select();
      try { document.execCommand('copy'); showShareToast(); } catch(e) {}
      document.body.removeChild(inp);
    }

    shareBtn.addEventListener('click', function () {
      if (navigator.share) {
        /* Ouvre le dialog natif — si l'utilisateur annule, on ne fait rien */
        navigator.share({ title: document.title, url: window.location.href }).catch(function () {});
      } else {
        /* Navigateur sans Web Share API : copier le lien + toast */
        copyFallback();
      }
    });
  });

  /* ── 1.11  Observer prix Shopify (synchro sens inverse) ──────── */
  /*    Quand Shopify met a jour le prix (via son propre systeme),  */
  /*    on repercute dans le bouton ATC sans decimales.             */

  if (atcPrice) {
    var priceContainer = document.getElementById('price-' + sectionId);
    if (priceContainer) {
      new MutationObserver(function () {
        if (updatingFromUI) return;
        var priceEl = priceContainer.querySelector('.price-item--regular')
                   || priceContainer.querySelector('.price-item--sale');
        if (priceEl) {
          var digits = priceEl.textContent.trim().replace(/[^\d]/g, '');
          if (digits) atcPrice.textContent = Math.round(parseInt(digits, 10) / 100) + ' \u20ac';
        }
      }).observe(priceContainer, { childList: true, subtree: true, characterData: true });
    }
  }

  /* ── 1.11.b  SAFETY NET : hook submit en phase capture ──────────
     Re-force l'ID variant juste avant que ProductForm.onSubmitHandler
     ne construise son FormData. Meme si quelque chose reset la valeur
     entre updateAll() et le clic ATC, on la remet au dernier moment.
     Capture=true garantit qu'on s'execute AVANT le listener de Shopify. */
  var allForms = document.querySelectorAll('form[action*="/cart/add"]');
  for (var fIdx = 0; fIdx < allForms.length; fIdx++) {
    allForms[fIdx].addEventListener('submit', function () {
      var vid = findVariantId();
      if (!vid) return;
      var input = this.querySelector('input[name="id"]');
      if (input) {
        input.disabled = false;
        input.removeAttribute('disabled');
        input.value = vid;
        input.setAttribute('value', vid);
      }
      /* Desactive temporairement les <select> caches pour qu'ils ne polluent
         pas le FormData. Shopify prendra juste l'input[name=id]. */
      var vs = document.querySelector('variant-selects');
      if (vs) {
        var sels = vs.querySelectorAll('select');
        for (var s = 0; s < sels.length; s++) {
          sels[s].disabled = true;
        }
        /* Re-active apres un tick pour ne pas casser d'autres choses */
        setTimeout(function () {
          for (var ss = 0; ss < sels.length; ss++) {
            sels[ss].disabled = false;
          }
        }, 100);
      }
    }, true);
  }

  /* ── 1.12  Debug overlay (activer avec ?bisou-debug=1) ──────────── */
  var debugBox = null;
  if (window.location.search.indexOf('bisou-debug=1') !== -1) {
    debugBox = document.createElement('div');
    debugBox.style.cssText = 'position:fixed;bottom:0;left:0;right:0;background:#000;color:#0f0;font:10px monospace;padding:8px;z-index:999999;max-height:40vh;overflow:auto;white-space:pre-wrap;line-height:1.4;border-top:2px solid #0f0;';
    document.body.appendChild(debugBox);
  }

  function debugDump(label) {
    if (!debugBox) return;
    var lines = [];
    lines.push('── ' + label + ' ──');
    lines.push('state: ' + JSON.stringify(state));
    lines.push('variants loaded: ' + variants.length);
    var vid = findVariantId();
    lines.push('findVariantId(): ' + vid);
    var forms = document.querySelectorAll('form[action*="/cart/add"]');
    lines.push('forms found: ' + forms.length);
    for (var i = 0; i < forms.length; i++) {
      var inp = forms[i].querySelector('input[name="id"]');
      lines.push('  form[' + i + '] input[name=id] = ' + (inp ? inp.value : 'NOT FOUND') + (inp && inp.disabled ? ' (disabled)' : ''));
    }
    var vs = document.querySelector('variant-selects');
    if (vs) {
      var ss = vs.querySelectorAll('select');
      lines.push('variant-selects exists, selects: ' + ss.length);
      for (var j = 0; j < ss.length; j++) {
        lines.push('  select[' + j + '] name=' + ss[j].name + ' value=' + ss[j].value);
        var selOpt = ss[j].querySelector('option[selected]');
        lines.push('    option[selected] = ' + (selOpt ? selOpt.textContent : 'NONE'));
      }
    } else {
      lines.push('variant-selects: NOT FOUND');
    }
    /* Prix dictionary + ATC display */
    lines.push('prices dict:');
    lines.push('  A4 cadre=' + prices.A4.cadre + ' sans=' + prices.A4.sans);
    lines.push('  A3 cadre=' + prices.A3.cadre + ' sans=' + prices.A3.sans);
    lines.push('  A2 cadre=' + prices.A2.cadre + ' sans=' + prices.A2.sans);
    var expectedPrice = state.withFrame ? prices[state.format].cadre : prices[state.format].sans;
    lines.push('expected ATC: ' + Math.round(expectedPrice / 100) + ' \u20ac');
    var atcEl = document.querySelector('.bisou-atc-price');
    lines.push('actual ATC text: ' + (atcEl ? atcEl.textContent : 'NOT FOUND'));
    /* Variant image info (direct swap) */
    var v = null;
    for (var m = 0; m < variants.length; m++) {
      if (variants[m].id === vid) { v = variants[m]; break; }
    }
    lines.push('variant.img URL: ' + (v && v.img ? v.img.substring(0, 80) + '...' : 'MISSING'));
    var gallery = document.querySelector('media-gallery');
    if (gallery) {
      var firstImg = gallery.querySelector('img');
      if (firstImg) {
        var curSrc = firstImg.getAttribute('src') || '';
        lines.push('gallery img src: ' + curSrc.substring(0, 80) + '...');
        lines.push('has srcset: ' + (firstImg.hasAttribute('srcset') ? 'YES (should be cleared)' : 'NO (good)'));
        if (v && v.img) {
          var match = curSrc.split('?')[0] === v.img.split('?')[0];
          lines.push('SRC MATCHES variant: ' + (match ? 'YES ✓' : 'NO ✗ → swap needed'));
        }
      } else {
        lines.push('gallery img: NOT FOUND');
      }
    }
    debugBox.textContent = lines.join('\n');
  }

  /* Hook debugDump apres chaque updateAll */
  var originalUpdateAll = updateAll;
  updateAll = function () {
    originalUpdateAll();
    debugDump('after updateAll');
  };

  /* ── 1.13  Initialisation ────────────────────────────────────── */
  /*    Dans l'editeur Shopify : pas de selectNativeVariant         */
  /*    (evite un crash quand variant-selects n'est pas pret).     */

  /* ── Couleur de cadre transmise par la carte cliquée (?frame=) : on ouvre la
        fiche sur la même finition que celle vue dans la grille d'origine. ── */
  (function applyIncomingFrame() {
    var col;
    try { col = new URLSearchParams(window.location.search).get('frame'); } catch (e) { return; }
    if (!col) return;
    col = col.toLowerCase();
    var alias = { black: 'noir', white: 'blanc', oak: 'chene', 'chêne': 'chene', birch: 'bouleau', sans: 'none', paper: 'none', papier: 'none' };
    col = alias[col] || col;
    if (col === 'none') { state.withFrame = false; state.color = 'none'; return; }
    if (LABELS[col]) { state.withFrame = true; state.color = col; }
  })();

  if (!window.Shopify || !Shopify.designMode) {
    updateAll();
  } else {
    updateStock();
    updateColorLabel();
    updateSwatches();
    updateFrameButtons();
    updateFormatRows();
    updateAtcPrice();
    updateShipping();
    updateEditionPanel();
    updateFormVariantId();
  }

})();


/* ================================================================
   2. S2 SCROLL ACCELERE
   La section "Associe le" remonte 1.3x plus vite que le scroll
   normal pour un effet reveal. Desactive sur mobile (< 900 px).
   ================================================================ */
(function () {
  'use strict';
  /* Effet de scroll accéléré DÉSACTIVÉ : la section suit le flux normal.
     ⚠ NE PAS poser de transform inline ici : sur mobile le CSS full-bleed
     de .rv5-associated repose sur translateX(-50%) — un transform:none
     inline décalait tout le bloc « Associez le » vers la droite. */
})();


/* ================================================================
   3. ASSOCIATED PRODUCTS (recommandations)
   Fetch des produits recommandes par Shopify, filtrage par
   orientation (V-/H- dans le titre), affichage de 2 cards max
   et mise a jour des images quand le variant principal change.
   ================================================================ */
(function () {
  'use strict';

  var container = document.getElementById('rv5-bloc-associated');
  if (!container) return;

  /* Pont i18n : deux aria-labels, posés par snippets/bisou-variant-ui.liquid.
     Repli français conservé si le pont manque. */
  var ASSOC_I18N = {};
  try { ASSOC_I18N = JSON.parse((document.getElementById('rv5-assoc-i18n') || {}).textContent || '{}'); } catch (e) {}
  function assocLabel(key, fallback) {
    var v = ASSOC_I18N[key];
    return (typeof v === 'string' && v) ? v : fallback;
  }

  var productId   = container.dataset.productId;
  var orientation = container.dataset.orientation;
  var grid        = container.querySelector('.rv5-associated-grid');
  if (!productId || !grid) return;

  var picks = [];

  /* ── Trouver l'image variant qui correspond a l'etat principal (bilingual) ── */
  function findVariantImage(product, st) {
    if (!product.variants || !st) return null;

    var fmt = st.format.toLowerCase();
    var isNone = !st.withFrame || st.color === 'none';

    for (var i = 0; i < product.variants.length; i++) {
      var v = product.variants[i];
      var vTitle = (v.title || '').toLowerCase();

      if (vTitle.indexOf(fmt) === -1) continue;

      if (isNone) {
        var isNoFrame = vTitle.indexOf('sans') !== -1
                     || vTitle.indexOf('no frame') !== -1
                     || vTitle.indexOf('unframed') !== -1
                     || vTitle.indexOf('papier') !== -1
                     || vTitle.indexOf('paper') !== -1;
        if (isNoFrame && v.featured_image) return v.featured_image.src;
      } else {
        var col = st.color;
        var cFr = col === 'chene' ? 'ch\u00eane' : col;
        var cEnMap = { 'noir': 'black', 'blanc': 'white', 'chene': 'oak', 'bouleau': 'birch' };
        var cEn = cEnMap[col];
        var hasColor = vTitle.indexOf(cFr) !== -1
                    || (cEn && vTitle.indexOf(cEn) !== -1)
                    || vTitle.indexOf(col) !== -1;
        var hasFrame = vTitle.indexOf('cadre') !== -1 || vTitle.indexOf('frame') !== -1;
        if (hasColor && hasFrame && v.featured_image) return v.featured_image.src;
      }
    }
    return null;
  }

  /* ── Generer le HTML des cards ── */
  function renderCards(st) {
    var html = '';
    picks.forEach(function (p, idx) {
      var imgUrl = findVariantImage(p, st);
      if (!imgUrl) {
        imgUrl = (typeof p.featured_image === 'string')
          ? p.featured_image
          : (p.featured_image && p.featured_image.src) || '';
      }
      if (imgUrl) imgUrl += (imgUrl.indexOf('?') === -1 ? '?' : '&') + 'width=400';

      var price  = (p.price / 100).toFixed(2).replace('.', ',') + ' \u20AC';
      var title  = p.title || '';

      var assocFrame = (!st.withFrame || st.color === 'none') ? 'none' : st.color;
      html += '<a href="' + p.url + '" class="rv5-assoc-card" data-assoc-idx="' + idx + '" data-bisou-frame="' + assocFrame + '">'
            +   '<div class="rv5-assoc-card-img">'
            +     '<img src="' + imgUrl + '" alt="' + title.replace(/"/g, '&quot;') + '" loading="lazy">'
            +   '</div>'
            +   '<div class="rv5-assoc-card-info">'
            +     '<div class="rv5-assoc-card-title">' + title + '</div>'
            +     '<div class="rv5-assoc-card-price">' + price + '</div>'
            +   '</div>'
            + '</a>';
    });
    grid.innerHTML = html;
  }

  /* ── Carrousel : wrapper + flèches desktop (le swipe mobile est natif) ── */
  function setupAssocCarousel() {
    if (container.dataset.assocCarousel) return;
    container.dataset.assocCarousel = '1';

    var wrap = document.createElement('div');
    wrap.className = 'rv5-assoc-wrap';
    grid.parentNode.insertBefore(wrap, grid);
    wrap.appendChild(grid);

    function arrow(dir) {
      var b = document.createElement('button');
      b.type = 'button';
      b.className = 'rv5-assoc-arrow rv5-assoc-arrow--' + (dir < 0 ? 'prev' : 'next');
      b.setAttribute('aria-label', dir < 0
        ? assocLabel('assoc_prev', 'Propositions précédentes')
        : assocLabel('assoc_next', 'Propositions suivantes'));
      b.innerHTML = dir < 0
        ? '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"><path d="M15 18l-6-6 6-6"/></svg>'
        : '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"><path d="M9 6l6 6-6 6"/></svg>';
      b.addEventListener('click', function () {
        var step = Math.round(grid.clientWidth / 2);
        grid.scrollBy({ left: dir * step, behavior: 'smooth' });
      });
      wrap.appendChild(b);
      return b;
    }
    var prev = arrow(-1);
    var next = arrow(1);

    function refreshArrows() {
      var max = grid.scrollWidth - grid.clientWidth;
      prev.hidden = grid.scrollLeft <= 1;
      next.hidden = grid.scrollLeft >= max - 1;
    }
    grid.addEventListener('scroll', refreshArrows, { passive: true });
    window.addEventListener('resize', refreshArrows);
    /* Départ TOUJOURS sur la première carte (mobile : évite tout désaxage) */
    grid.scrollLeft = 0;
    setTimeout(function () { grid.scrollLeft = 0; refreshArrows(); }, 0);
    /* renderCards remplace l'innerHTML du grid à chaque changement de variante :
       le wrapper et les flèches vivent en dehors, rien à refaire. */
  }

  /* ── Fetch & affichage ── */
  var rootUrl = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  fetch(rootUrl + 'recommendations/products.json?product_id=' + productId + '&limit=10')
    .then(function (r) { return r.json(); })
    .then(function (data) {
      var products = data.products || [];
      if (!products.length) { container.style.display = 'none'; return; }

      /* Orientation d'un produit recommande : la balise orientation-* que l'App
         pose sur les fiches v2. Repli sur le prefixe H-/V- du titre pour les
         tirages encore en v1, dont le titre EST la reference. Ce repli tombera
         quand les 35 seront bascules. */
      var wantTag = orientation === 'horizontal' ? 'orientation-horizontal' : 'orientation-vertical';
      var prefix  = orientation === 'horizontal' ? 'H-' : 'V-';
      var filtered = products.filter(function (p) {
        var tags = p.tags || [];
        if (tags.indexOf('orientation-horizontal') !== -1 || tags.indexOf('orientation-vertical') !== -1) {
          return tags.indexOf(wantTag) !== -1;
        }
        return p.title && p.title.toUpperCase().indexOf(prefix) === 0;
      });

      /* Carrousel : jusqu'à 8 propositions (orientation assortie en premier),
         2 visibles à la fois — flèches desktop, swipe mobile. */
      var rest = products.filter(function (p) { return filtered.indexOf(p) === -1; });
      picks = filtered.concat(rest).slice(0, 8);
      if (!picks.length) { container.style.display = 'none'; return; }

      renderCards(window.__bisouState);
      setupAssocCarousel();
    })
    .catch(function () {
      container.style.display = 'none';
    });

  /* ── Ecouter les changements de variant sur le produit principal ── */
  document.addEventListener('bisou:variant-change', function (e) {
    if (picks.length) renderCards(e.detail);
  });
})();
